import { render, staticRenderFns } from "./tableHistory.vue?vue&type=template&id=f59347a8&scoped=true&"
import script from "./tableHistory.vue?vue&type=script&lang=js&"
export * from "./tableHistory.vue?vue&type=script&lang=js&"
import style0 from "./tableHistory.vue?vue&type=style&index=0&id=f59347a8&scoped=true&lang=css&"
import style1 from "./tableHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59347a8",
  null
  
)

export default component.exports